import type { Dayjs } from "@/lib/dayjs";
import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { DAY_OF_THE_WEEK_I18N } from "@/components/ui/calendar/constants";

import type { CalendarDayType } from "./types";

export function createCalendarDay({
	date,
	lang,
	isDifferentMonth = false,
}: {
	date: Dayjs;
	lang: LangCode;
	isDifferentMonth?: boolean;
}): CalendarDayType {
	return {
		fullDate: date.format("YYYY-MM-DD"),
		year: date.year().toString(),
		month: (date.month() + 1).toString(),
		date: date.date().toString(),
		dayOfTheWeek: DAY_OF_THE_WEEK_I18N[date.day()][lang],
		isDifferentMonth,
	};
}
